/* eslint-disable eqeqeq */
import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { API, get, imageDefaultPrefixPath } from "../../config";
import { checkIfFileExists } from "./Misc";

// Create the ProjectContext
const ProjectContext = createContext();

// Create the ProjectProvider component
export function ProjectProvider({ children }) {
  const params = useParams();
  const location = useLocation();
  const projectId = params?.project_id;
  const [projectData, setProjectData] = useState(null);
  const [ProjectName, setProjectName] = useState();
  const [ProjectLogo, setProjectLogo] = useState();
  const [ProjectAccess, setProjectAccess] = useState();
  const [ProjectReadOnly, setProjectReadOnly] = useState();
  const [ProjectBuilderId, setProjectBuilderId] = useState(null);
  // const previousProjectIdRef = useRef(null);

  // Fetch project data if projectId changes and projectData is not already set
  useEffect(() => {
    // if (projectId && projectId !== previousProjectIdRef.current) {
    if(location.pathname.includes("/projects/") && projectId) {
      fetchProjectData(projectId);
      // previousProjectIdRef.current = projectId;
    }
  }, [location.pathname, projectId]);

  const fetchProjectData = async (id) => {
    try {
      
      const { data } = await get(`${API.PROJECT_DETAILS}/` + id);
      setProjectData(data?.data);
      setProjectName(data?.data?.project_name);
      setProjectLogo(data?.data?.logo);
      setProjectReadOnly &&
        setProjectReadOnly(
          data?.data?.subscription?.status == 0 ||
            data?.data?.project_status == 1 ||
            !data?.data?.subscription
            ? true
            : false
        );
      setProjectAccess &&
        setProjectAccess(data?.data?.subscription ? true : false);
      data?.data?.builder_id && localStorage.setItem("builderId", data?.data?.builder_id);
      setProjectBuilderId && setProjectBuilderId(data?.data?.builder_id);
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  };

  useEffect(() => {
    if (ProjectLogo && typeof ProjectLogo === "string") {
      checkIfFileExists(`${imageDefaultPrefixPath}${ProjectLogo}`, (exists) => {
        if (exists) {
          setProjectLogo(ProjectLogo);
        } else {
          setProjectLogo("");
        }
      });
    } else {
      setProjectLogo("");
    }
  }, [ProjectLogo]);


  // Function to update project data conditionally
  const updateProjectData = (newData) => {
    setProjectData((prevData) => (prevData !== newData ? newData : prevData));
  };

  const updateProjectLogo = (newData) => {
    setProjectLogo(newData);
  };

  const fetchProjectContext = () => {
    fetchProjectData(projectId);
  }

  // Define the context value object
  const contextValue = {
    projectData,
    updateProjectData,
    ProjectName,
    ProjectLogo,
    ProjectAccess,
    ProjectBuilderId,
    ProjectReadOnly,
    updateProjectLogo,
    fetchProjectContext
  };

  return (
    <ProjectContext.Provider value={contextValue}>
      {children}
    </ProjectContext.Provider>
  );
}

// Custom hook to use the ProjectContext
export function useProject() {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error("useProject must be used within a ProjectProvider");
  }
  return context;
}
